import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Table
} from 'react-lib/frameworks/Table'
import {
  FormGroup,
  FormField,
  Input,
  Dropdown
} from 'semantic-ui-react'
import {
  DateTextBox
} from 'react-lib/apps/common'

const CardGenerateContinueByPlanUX = (props: any) => {

    const isMounted = React.useRef(true);
    const intl = useIntl();

    React.useEffect(() => {
        return () => {
            isMounted.current = false;
        };
    }, []);


    return(
      <div
        id="CardGenerateContinueByPlanUX-div-0"
        style={{height:"100%",padding:"10px"}}>
        <div
          className="ui form"
          id="CardGenerateContinueByPlanUX-div-1"
          style={{ marginBottom: "40px" }}>

          <FormGroup
            id="CardGenerateContinueByPlanUX-FormGroup-5"
            inline={true}>
            <FormField
              id="CardGenerateContinueByPlanUX-FormField-6"
              inline={true}>
              <div
                id="CardGenerateContinueByPlanUX-div-11"
                style={{ width: "100%", display: "flex", alignItems: "center", gap: "20px" } }>

                <label
                  id="CardGenerateContinueByPlanUX-label-16">
                  Date
                </label>
                <DateTextBox
                  id="CardGenerateContinueByPlanUX-DateTextBox-19"
                  onChange={props.onChangeDate}
                  value={props.searchContinue?.created_date || ""}>
                </DateTextBox>
              </div>
            </FormField>
            <FormField
              id="CardGenerateContinueByPlanUX-FormField-7"
              inline={true}>
              <div
                id="CardGenerateContinueByPlanUX-div-12"
                style={{ width: "100%", display: "flex", alignItems: "center", gap: "20px" } }>

                <label
                  id="CardGenerateContinueByPlanUX-label-17">
                  HN
                </label>
                <Input
                  id="CardGenerateContinueByPlanUX-Input-20"
                  name="hn"
                  onChange={props.onChangeData}
                  value={props.searchContinue?.hn || ""}>
                </Input>
              </div>
            </FormField>
            <FormField
              id="CardGenerateContinueByPlanUX-FormField-8"
              inline={true}
              width="4">
              <div
                id="CardGenerateContinueByPlanUX-div-13"
                style={{ width: "100%", display: "flex", alignItems: "center", gap: "20px" } }>

                <label
                  id="CardGenerateContinueByPlanUX-label-18">
                  Division
                </label>
                <Dropdown
                  clearable={true}
                  fluid={true}
                  id="CardGenerateContinueByPlanUX-Dropdown-21"
                  name="division"
                  onChange={props.onChangeData}
                  options={props.divisionOptions }
                  search={true}
                  selection={true}
                  value={props.searchContinue?.division || ""}>
                </Dropdown>
              </div>
            </FormField>
            <FormField
              id="CardGenerateContinueByPlanUX-FormField-9"
              inline={true}>
              <div
                id="CardGenerateContinueByPlanUX-div-14"
                style={{ width: "100%" } }>

                <div
                  id="CardGenerateContinueByPlanUX-div-22">
                  {props.searchButton}
                </div>
              </div>
            </FormField>
            <FormField
              id="CardGenerateContinueByPlanUX-FormField-10"
              inline={true}>
              <div
                id="CardGenerateContinueByPlanUX-div-15"
                style={{ width: "100%" } }>

                <div
                  id="CardGenerateContinueByPlanUX-div-23">
                  {props.generateButton}
                </div>
              </div>
            </FormField>
          </FormGroup>
        </div>
        <div
          id="CardGenerateContinueByPlanUX-div-2">

          <Table
            className="--rt-tbody-overflow-y-hidden"
            columns={props.tableHeaders}
            data={props.continueList}
            id="CardGenerateContinueByPlanUX-Table-3"
            minRows="5"
            onPageChange={props.onPageChange}
            onPageSizeChange={props.onPageSizeChange}
            page={props.paginatedItems?.page || 0}
            pageSize={props.paginatedItems?.pageSize || 0}
            pages={Math.ceil(props.paginatedItems?.total / props.paginatedItems?.pageSize)}
            style={{ height: "calc(95vh - 14.5rem)"}}>
          </Table>
        </div>
      </div>
    )
}


export default CardGenerateContinueByPlanUX

export const screenPropsDefault = {}

/* Date Time : Mon Jul 14 2025 18:19:38 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardGenerateContinueByPlanUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{height:\"100%\",padding:\"10px\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardGenerateContinueByPlanUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{ marginBottom: \"40px\" }"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardGenerateContinueByPlanUX-div-2"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 3,
      "name": "Table",
      "parent": 2,
      "props": {
        "className": {
          "type": "value",
          "value": "--rt-tbody-overflow-y-hidden"
        },
        "columns": {
          "type": "code",
          "value": "props.tableHeaders"
        },
        "data": {
          "type": "code",
          "value": "props.continueList"
        },
        "id": {
          "type": "value",
          "value": "CardGenerateContinueByPlanUX-Table-3"
        },
        "minRows": {
          "type": "value",
          "value": "5"
        },
        "onPageChange": {
          "type": "code",
          "value": "props.onPageChange"
        },
        "onPageSizeChange": {
          "type": "code",
          "value": "props.onPageSizeChange"
        },
        "page": {
          "type": "code",
          "value": "props.paginatedItems?.page || 0"
        },
        "pageSize": {
          "type": "code",
          "value": "props.paginatedItems?.pageSize || 0"
        },
        "pages": {
          "type": "code",
          "value": "Math.ceil(props.paginatedItems?.total / props.paginatedItems?.pageSize)"
        },
        "style": {
          "type": "code",
          "value": "{ height: \"calc(95vh - 14.5rem)\"}"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 5,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardGenerateContinueByPlanUX-FormGroup-5"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 6,
      "name": "FormField",
      "parent": 5,
      "props": {
        "id": {
          "type": "value",
          "value": "CardGenerateContinueByPlanUX-FormField-6"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 7,
      "name": "FormField",
      "parent": 5,
      "props": {
        "id": {
          "type": "value",
          "value": "CardGenerateContinueByPlanUX-FormField-7"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 8,
      "name": "FormField",
      "parent": 5,
      "props": {
        "id": {
          "type": "value",
          "value": "CardGenerateContinueByPlanUX-FormField-8"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "value",
          "value": "4"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 9,
      "name": "FormField",
      "parent": 5,
      "props": {
        "id": {
          "type": "value",
          "value": "CardGenerateContinueByPlanUX-FormField-9"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 10,
      "name": "FormField",
      "parent": 5,
      "props": {
        "id": {
          "type": "value",
          "value": "CardGenerateContinueByPlanUX-FormField-10"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": null,
      "id": 11,
      "name": "div",
      "parent": 6,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardGenerateContinueByPlanUX-div-11"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", display: \"flex\", alignItems: \"center\", gap: \"20px\" } "
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": null,
      "id": 12,
      "name": "div",
      "parent": 7,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardGenerateContinueByPlanUX-div-12"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", display: \"flex\", alignItems: \"center\", gap: \"20px\" } "
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": null,
      "id": 13,
      "name": "div",
      "parent": 8,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardGenerateContinueByPlanUX-div-13"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", display: \"flex\", alignItems: \"center\", gap: \"20px\" } "
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": null,
      "id": 14,
      "name": "div",
      "parent": 9,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardGenerateContinueByPlanUX-div-14"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" } "
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": null,
      "id": 15,
      "name": "div",
      "parent": 10,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardGenerateContinueByPlanUX-div-15"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" } "
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": null,
      "id": 16,
      "name": "label",
      "parent": 11,
      "props": {
        "children": {
          "type": "value",
          "value": "Date"
        },
        "id": {
          "type": "value",
          "value": "CardGenerateContinueByPlanUX-label-16"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": null,
      "id": 17,
      "name": "label",
      "parent": 12,
      "props": {
        "children": {
          "type": "value",
          "value": "HN"
        },
        "id": {
          "type": "value",
          "value": "CardGenerateContinueByPlanUX-label-17"
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": null,
      "id": 18,
      "name": "label",
      "parent": 13,
      "props": {
        "children": {
          "type": "value",
          "value": "Division"
        },
        "id": {
          "type": "value",
          "value": "CardGenerateContinueByPlanUX-label-18"
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 19,
      "name": "DateTextBox",
      "parent": 11,
      "props": {
        "id": {
          "type": "value",
          "value": "CardGenerateContinueByPlanUX-DateTextBox-19"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeDate"
        },
        "value": {
          "type": "code",
          "value": "props.searchContinue?.created_date || \"\""
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 20,
      "name": "Input",
      "parent": 12,
      "props": {
        "id": {
          "type": "value",
          "value": "CardGenerateContinueByPlanUX-Input-20"
        },
        "name": {
          "type": "value",
          "value": "hn"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "code",
          "value": "props.searchContinue?.hn || \"\""
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 21,
      "name": "Dropdown",
      "parent": 13,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardGenerateContinueByPlanUX-Dropdown-21"
        },
        "name": {
          "type": "value",
          "value": "division"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "options": {
          "type": "code",
          "value": "props.divisionOptions "
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.searchContinue?.division || \"\""
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": null,
      "id": 22,
      "name": "div",
      "parent": 14,
      "props": {
        "children": {
          "type": "code",
          "value": "props.searchButton"
        },
        "id": {
          "type": "value",
          "value": "CardGenerateContinueByPlanUX-div-22"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": null,
      "id": 23,
      "name": "div",
      "parent": 15,
      "props": {
        "children": {
          "type": "code",
          "value": "props.generateButton"
        },
        "id": {
          "type": "value",
          "value": "CardGenerateContinueByPlanUX-div-23"
        }
      },
      "seq": 23,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": true,
  "name": "CardGenerateContinueByPlanUX",
  "project": "CLM CU",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
